import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import AppWithProviders from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppWithProviders />
    </BrowserRouter>
  </React.StrictMode>
);

// Register the service worker for PWA functionality (skip in local/dev to avoid SW errors)
if (process.env.NODE_ENV === 'production' && window.location.hostname !== 'localhost') {
  serviceWorkerRegistration.register({
    onSuccess: (registration) => {
      console.log('PWA: App is ready for offline use');
    },
    onUpdate: (registration) => {
      console.log('PWA: New version available');
    }
  });

  // Initialize PWA features
  serviceWorkerRegistration.initializePWA();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
